import React from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { useSelector } from 'react-redux';

import RadialBar from './RadialBar.jsx';
import NoChartsData from '../../no-charts-data/NoChartsData.jsx';

import scss from './RadialBars.module.scss';

const RadialBars = ({ data, dataKey }) => {
  const theme = useSelector((state) => state.global.theme);

  if (!data.length) {
    return <NoChartsData />;
  }

  return (
    <ReactResizeDetector handleWidth>
      {({ width }) => (
        <div className={scss.container}>
          {width !== undefined &&
            getIndices(data.length, width).map(([start, end], i) => (
              <DomainsRow data={data.slice(start, end)} dataKey={dataKey} theme={theme} key={`DomainRow-${i}`} />
            ))}
        </div>
      )}
    </ReactResizeDetector>
  );
};

const DomainsRow = ({ data, dataKey, theme }) => {
  return (
    <div className={scss.row}>
      {data.map(({ domain, label, [dataKey]: { score, trend }, inFocus, myCompany }) => (
        <RadialBar
          domain={domain}
          label={label}
          score={score}
          trend={trend}
          inFocus={inFocus}
          myCompany={myCompany}
          theme={theme}
          key={`${domain}-trust-chart`}
        />
      ))}
    </div>
  );
};

export default RadialBars;

const getIndices = (number, width) => {
  const rowSizes = getDomainsPerRowMap(number, width);
  let counter = 0;
  const indices = rowSizes.map((size) => {
    const indexRange = [counter, counter + size];
    counter += size;
    return indexRange;
  });

  return indices;
};

const getWidthId = (width) => {
  if (width > 1260) {
    return 'xl';
  }
  if (width > 700) {
    return 'lg';
  }
  if (width > 520) {
    return 'md';
  }
  if (width > 320) {
    return 'sm';
  }
  return 'xs';
};

const getOneColIndices = (number) => {
  return new Array(number).fill(1);
};

const MAX_SIZE_PER_CHUNK = 10;

const divideNumberIntoChunks = (number) => {
  return Array.from({ length: Math.ceil(number / MAX_SIZE_PER_CHUNK) }, (_, index) => {
    const chunkSize = Math.min(10, number - index * MAX_SIZE_PER_CHUNK);
    return chunkSize;
  });
};

const getDomainsPerRowMap = (number, width) => {
  const widthId = getWidthId(width);
  const chunks = divideNumberIntoChunks(number);

  return chunks.flatMap((chunkNumber) => {
    const oneCol = getOneColIndices(chunkNumber);

    return (
      {
        10: {
          xl: [5, 5],
          lg: [3, 4, 3],
          md: [2, 3, 3, 2],
          sm: [2, 2, 2, 2, 2],
          xs: oneCol,
        }[widthId],

        9: {
          sm: [2, 2, 2, 2, 1],
          xs: oneCol,
        }[widthId] || [3, 3, 3],

        8: {
          md: [3, 3, 2],
          sm: [2, 2, 2, 2],
          xs: oneCol,
        }[widthId] || [4, 4],

        7: {
          md: [2, 2, 3],
          sm: [2, 2, 2, 1],
          xs: oneCol,
        }[widthId] || [4, 3],

        6: {
          sm: [2, 2, 2],
          xs: oneCol,
        }[widthId] || [3, 3],

        5: {
          xl: [5],
          lg: [3, 2],
          md: [3, 2],
          sm: [2, 2, 1],
          xs: oneCol,
        }[widthId],

        4: {
          md: [2, 2],
          sm: [2, 2],
          xs: oneCol,
        }[widthId] || [4],

        3: {
          sm: [2, 1],
          xs: oneCol,
        }[widthId] || [3],
        2: {
          xs: oneCol,
        }[widthId] || [2],

        1: oneCol,
      }[chunkNumber] || [chunkNumber]
    );
  });
};
